var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditMenuIcon = function SvgEditMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#5c34cd",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.968 3.383a1.5 1.5 0 0 0-2.121 0l-1.16 1.16 2.77 2.77 1.16-1.16a1.5 1.5 0 0 0 0-2.121zM12.385 8.385l-2.77-2.77L3.82 11.41l-.605 2.771a.5.5 0 0 0 .601.594l2.837-.657z"
  })));
};
export default SvgEditMenuIcon;